module.exports = __webpack_public_path__ + "static/media/middle-right-2.952b93b9.png";